import * as React from "react";
import * as url from "url";
// import components
import {
  Container,
  Content,
  ContentContainer,
  Description,
  Image,
  Title,
  Url,
} from "./styledComponents";
import ShavedText from "common/components/shavedText";
import Icon from "common/icons";
import PACKS from "common/icons/packs";

interface IProps extends React.HTMLProps<HTMLAnchorElement> {
  linkPreview: Vingle.ILinkPreview;
}

const LinkPreview = (props: IProps) => {
  const { linkPreview, ref: _ref, href: _href, as, ...rest } = props;
  let titleElement = null;
  let descriptionElement = null;
  let urlElement = null;
  let imageElement = null;
  if (linkPreview.title) {
    titleElement = (
      <Title>
        <ShavedText value={decodeURIComponent(linkPreview.title)} line={2} />
      </Title>
    );
  } // ${px2rem(28)} per line
  if (linkPreview.description) {
    descriptionElement = (
      <Description>
        <ShavedText value={linkPreview.description} line={2} />
      </Description>
    ); // 24px per line
  }
  if (linkPreview.url) {
    const host = url.parse(linkPreview.url).hostname;
    urlElement = (
      <Url>
        {host}
        <Icon icon={PACKS.LINKPREVIEW_ARROW} />
      </Url>
    );
  }
  if (linkPreview.image) {
    imageElement = (
      <Image style={{ backgroundImage: `url(${linkPreview.image})` }} />
    );
  }

  return (
    <Container href={linkPreview.url} target="_blank" {...rest}>
      <ContentContainer>
        <Content>
          {titleElement}
          {descriptionElement}
          {urlElement}
        </Content>
        {imageElement}
      </ContentContainer>
    </Container>
  );
};

export default LinkPreview;
